import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * The signed-in user's own records clocked in between `fromDate` and `toDate`
 * (ISO timestamps), on every project: the personal work calendar's GET
 * workflow/mylixani/personal/{fromDate}/{toDate}. The API reads them by the
 * caller's own resources (the Record table's resource/clockInAt index, as
 * for today's records), deleted ones left out, so the answer holds no one
 * else's records. It answers 404 to a user with no resources: no records.
 * @param {{fromDate: string, toDate: string}} timeframe
 * @returns {Promise<Object[]>} the records
 */
export const getOwnRecordsInTimeframe = async ({ fromDate, toDate }) => {
  const apiPath = `workflow/mylixani/personal/${fromDate}/${toDate}`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  try {
    const response = await axios(signedRequest);
    return response.data?.records || [];
  } catch (error) {
    if (error?.response?.status === 404) return [];
    throw error;
  }
};
